import { render } from "./sidebarSlot.vue?vue&type=template&id=21215cf4&scoped=true"
import script from "./sidebarSlot.vue?vue&type=script&lang=js"
export * from "./sidebarSlot.vue?vue&type=script&lang=js"

import "./sidebarSlot.vue?vue&type=style&index=0&id=21215cf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21215cf4"]])

export default __exports__